import moment from 'moment'
import createPaginationModule from '../generic/pagination'
import createSingleItemCrudModule from '../generic/single-item-crud'
import { putEmailNotificationMarkAsReadApi } from './logistics-apis'
import { NOTIFICATIONS_EMAIL_SUGGESTIONS, NOTIFICATION_EMAIL_ALLOWED_SEARCH_INPUTS } from './search-inputs'
import { RETRIEVE } from '@/constants/store-actions'
const endpoint = '/user_api/v1/email_notifications'
const url = (
  process.env.VUE_APP_USER_API_ENDPOINT +
  endpoint
)

function parseEmailItems (item) {
  return {
    user_email: item.user_email,
    plant: item.plant,
    planner_group: item.planner_group,
    storage_location: item.storage_location,
    work_center: item.work_center,
    subject: item.subject,
    message: item.message,
    created: moment(item.created).format('lll')
  }
}

export default {
  namespaced: true,
  modules: {
    emailPagination: createPaginationModule(
      {
        endpoint: url,
        mapper: parseEmailItems
      }),
    emailCrud: createSingleItemCrudModule(
      {
        endpoint: url,
        actions: [RETRIEVE]
      })
  },
  state: {
  },
  getters: {
    searchSuggestionsList (state) {
      return NOTIFICATIONS_EMAIL_SUGGESTIONS
    },
    allowedSearchInputs (state) {
      return NOTIFICATION_EMAIL_ALLOWED_SEARCH_INPUTS
    }
  },
  actions: {
    async markAsRead ({ commit }, id) {
      const requestPromise = putEmailNotificationMarkAsReadApi(id)
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.error({ _: 'Mark Email Notification As Read failed', error })
        })
      return requestPromise
    }
  }
}
